module.exports = __webpack_public_path__ + "img/flight-deck-gal-2.a3f0ab63.jpg";